const DEFAULT_NCM_ERROR_MESSAGE =
  "Não foi possível corrigir o NCM. Verifique o código informado.";

const NCM_ERROR_RULES: {
  pattern: RegExp;
  build: (match: RegExpExecArray) => string;
}[] = [
  {
    pattern: /cannot be the same as the old one/i,
    build: () => "Novo NCM não pode ser igual ao atribuído, por favor corrija.",
  },
  {
    pattern: /NCM\s+([\d.]+)\s+is not available in the catalog/i,
    build: (match) =>
      `NCM ${match[1]} não está disponível no catálogo, por favor corrija.`,
  },
  {
    pattern: /is not available in the catalog/i,
    build: () => "NCM informado não está disponível no catálogo, por favor corrija.",
  },
];

export const resolveNcmErrorMessage = (apiMessage?: string | null): string => {
  if (!apiMessage) {
    return DEFAULT_NCM_ERROR_MESSAGE;
  }

  for (const rule of NCM_ERROR_RULES) {
    const match = rule.pattern.exec(apiMessage);

    if (match) {
      return rule.build(match);
    }
  }

  return DEFAULT_NCM_ERROR_MESSAGE;
};

export default resolveNcmErrorMessage;
